export const GAME_SERVER_PORT = 2567;
export const ROOM_NAME = 'deathmatch';
export const DEFAULT_VOID_NAME = 'The Void';
export const TICK_RATE = 60; // Server fixed-step Hz
export const RESPAWN_DELAY_SECONDS = 2;

export const WORLD_WIDTH = 3200;
export const WORLD_HEIGHT = 3200;

// Ships bounce at this distance from each edge; asteroid belt fills this band.
export const BORDER_THICKNESS = 80;

export const SHIP_ROTATION_SPEED = 3.5; // radians/sec

/** Extra collision radius added when a ship's shields are up. */
export const SHIELD_RADIUS_BONUS = 12;
export const SHIP_THRUST_FORCE = 220;   // pixels/sec²
export const SHIP_DECEL_FORCE = 110;    // applied when DOWN held
export const SHIP_MAX_SPEED = 600;      // pixels/sec (magnitude cap)
